<template>
	<inertia-head title="Bo Sanchez FREE Ebook - Seven Success Principles" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Delivery Freebook
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Discover the Seven Success Principles from the Ancient Book of Proverbs for Your Money, Work and Life
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				<h2 class="text-center">Put Your Name and Email Below To Get Your FREE book</h2>
				<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="form-group mb-4">
							<label>First Name</label>
							<input type="text" v-model="form.fname" name="fname" class="form-control" />
							<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
						</div>
						<div class="form-group mb-4">
							<label>Last Name</label>
							<input type="text" v-model="form.lname" name="lname" class="form-control" />
							<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
						</div>
						<div class="form-group mb-4">
							<label>Email Address</label>
							<input type="text" v-model="form.email" name="email" class="form-control" />
							<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
						</div>
						<div class="form-group mb-4">
							<label>Mobile</label>
							<vue-tel-input
								@input="onInput"
								@countryChanged="onCountryChange"
								v-model="form.mobile"
								:value="form.mobile"
								class="form-control"
								:class="{ 'is-invalid': form.errors.mobile }"
								:input-options="{
									placeholder: 'Enter mobile number',
								}"
								:defaultCountry="form.country_code"
								mode="international"
							/>
						</div>
						<div class="form-group mb-4">
							<label>Full Address</label>
							<input type="text" v-model="form.address" name="address" class="form-control" />
							<span v-if="form.errors.address" class="text-danger">{{form.errors.address}}</span>
						</div>
						<div class="mb-4">
							<div class="form-group mb-4">
								<label class="form-label">Country</label>
								<select v-model="form.country" id="country" name="country" class="form-select">
									<option value="Philippines">Philippines</option>
								</select>
								<div v-if="form.errors.country && form.country==''" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.country }}
								</div>
							</div>
							<div v-if="form.country=='Philippines'" class="mb-4">
								<div class="form-group mb-4">
									<label class="form-label">Province</label>
									<select v-model="form.province" id="province" name="province" class="form-select">
										<option v-for="province in provinces" :value="province.prov_code+'|'+province.prov_desc">{{province.prov_desc}}</option>
									</select>
									<div v-if="form.errors.province && form.province==''" class="show-error">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.province }}
									</div>
								</div>
								<div class="form-group mb-4">
									<label class="form-label">City</label>
									<select v-model="form.city" id="city" name="city" class="form-select">
										<option v-for="city in cities[(form.province).split('|')[0]]" :value="city.citymun_code+'|'+city.citymun_desc">{{city.citymun_desc}}</option>
									</select>
									<div v-if="form.errors.city && form.city==''" class="show-error">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.city }}
									</div>
								</div>
								<div class="form-group mb-4">
									<label class="form-label">Barangay</label>
									<select v-model="form.barangay" id="barangay" name="barangay" class="form-select">
										<option v-for="brgy in barangay[(form.city).split('|')[0]]" :value="brgy.brgy_desc">{{brgy.brgy_desc}}</option>
									</select>
									<div v-if="form.errors.barangay && form.barangay==''" class="show-error">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.barangay }}
									</div>
								</div>
							</div>
						</div>
						<hr/>
						<div class="mb-4">
							<label>Payment Method</label>
							<div class="row">
								<div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											value="CARD"
											id="card"
											name="mop"
										/>
										<label class="form-check-label" for="card">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/stripe-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY'"
											id="dragonpay"
											name="mop"
										/>
										<label class="form-check-label" for="dragonpay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/dragonpay-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
							</div>
						</div>
						<div v-if="form.mop=='CARD'" class="mb-4">
							<div class="form-group mb-4">
								<label class="form-label">Card</label>
								<stripe @accept-token="acceptToken" ref="stripe" />
								<div v-if="form.errors.card" class="invalid-feedback d-block">
									{{ form.errors.card }}
								</div>
							</div>
						</div>
						<div v-if="form.province!='' && form.city!=='' && form.barangay!==''" class="mb-4">
							<div class="form-group mb-4">
								<p class="text-center fw-bold h3">Delivery Fee: PHP {{form.amount}}</p>
							</div>
						</div>
						<div class="form-group mt-4 text-center">
							<button @click="deliveryBook" type="button" class="btn btn-success" :disabled="form.processing">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-envelope me-1"></i>
								Send My Freebook Now!
							</button>
						</div>
						
					</div>
				</div>
				<div class="block-content block-content-full">
					<p class="text-gray-dark">Disclaimer:
						We're excited for the free book you're receiving from us! By subscribing to our newsletter, 
					you'll stay updated on our latest offerings, special promotions, and valuable content. Your email 
				address is safe with us, and we will never share it with others. If you ever wish to unsubscribe, you 
			can do so easily at any time. Thank you for joining our community and being a part of our financial freedom journey!</p>
				</div>
				<div class="block-content block-content-full">
					<p class="text-center">Your referring affiliate is: {{affiliate_name}}</p>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import Stripe from '../Shared/Components/Stripe';
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: GuestLayout,
		props:{
			flash 			: Object,
			affiliate		: Number,
			affiliate_name	: String,
			countries 		: Object,
			provinces 		: Object,
			cities 			: Object,
			barangay 		: Object
		},
		components: {
			Stripe,
		},
		setup(props){

			const form = useForm({
				fname 				: '',
				lname 				: '',
				email 				: '',
				country_calling_code: '63',
				country_code 		: 'PH',
				mobile				: '',
				address				: '',
				country				: 'Philippines',
				province			: '',
				city				: '',
				barangay			: '',
				mop					: 'CARD',
				token				: null,
				amount				: 0,
				affiliate_id 		: props.affiliate
			})

			const acceptToken = (token) => { form.token = token }

			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
					form.mobile 				= phoneObject.number;
					form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}

			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}

			const deliveryBook = ()=>{
				form.post(route("delivery-freebook-store"),{
					only:['flash,errors']
				});
			}

			watch(
				() => form.mop,
				(mop) => {

					if(mop!='CARD')
					{
						form.token = null;
					}
				}
			)

			watch(
				() => form.province,
				(province) => {

					if(province=='1339|Metro Manila')
					{
						form.amount = 197;
					}else{
						form.amount = 254;
					}

					form.city = '';
					form.barangay = '';
				}
			)

			watch(
				() => form.city,
				(city) => {
					form.barangay = '';
				}
			)

			watch(
				() => props.flash,
				(flash) => {
					if (flash && flash.toast) {
						if(flash.toast.type=='success')
						{
							Inertia.get("freebook/thankyou/"+flash.toast.data);
						}
						
					}
				}
			)

			return {
				form,
				onInput,
				onCountryChange,
				acceptToken,
				deliveryBook
			}

		}
	}
</script>